var articleFeatures = (function () {
    'use strict';

    var _share = function () {
        if ($('.article-body .share').length > 0) {

            var attrs = {};
            $.each($('.share'), function () {
                var content = $(this).text(),
                    title = $(document).find('title').text(),
                    url = window.location.href,
                    twitter = 'http://twitter.com/share?text=' + content + '&url=' + url,
                    linkedIn = 'https://www.linkedin.com/shareArticle?mini=true&url=' + url + '/&title=' + title + '&summary=' + content;

                $(this).append('<div class="share-tools"><a href="' + twitter + '" title="Share on Twitter"><span class="icon-twitter"></span></a><a href="' + linkedIn + '" title="Share on LinkedIn"><span class="icon-linkedin"></span></a></div>');
            });

        }
    };

    var _cite = function () {
        if ($('.article-body .cite').length > 0) {

            var attrs = {};
            $.each($('.cite')[0].attributes, function (idx, attr) {
                attrs[attr.nodeName] = attr.nodeValue;
            });
            $('.cite').replaceWith(function () {
                return $("<cite />", attrs).append($(this).contents());
            });

        }
    };

    function init() {
        _cite();
        _share();
    }

    return {
        init: init
    };
}());

$('.expandable-initial').on('click', function () {
    var target = $(this).closest('.expandable');
    if (target.hasClass('open') && $(this).hasClass('open-only') !== true) {
        target.removeClass('open');
    } else {
        target.addClass('open');
    }
    if ($(this).hasClass('open-only') !== true) {
        return false;
    }
});

function getPageUrlWithoutCountry(href) {
    console.log(href);
    return href;
}

function storyProgress() {

    if ($('body').hasClass('single-post')) {

        var storyBodyHeight = $('.article-body').height(),
            mastHeadHeight = $('.masthead').outerHeight(),
            storyBodyTop = $('.article-body').offset().top,
            currScroll = $(document).scrollTop(),
            winHeight = $(window).height(),
            visionLine = currScroll + (winHeight * .4), // somewhere between top and bottom of the window 0 being top, 1 being bottom
            calc = ((visionLine - storyBodyTop) / storyBodyHeight) * 100;

        if (calc >= 0 && calc <= 100) {

            if ($('#storyProgress').length < 1) {

                var storyTitle = $('h1').text();

                $('.bloglayout--wrap').append('<div id="storyProgress" class="on" style="top:' + mastHeadHeight + 'px"><div class="container"><p><strong>Currently reading...</strong>' + storyTitle + '</p></div><div class="progressBar" style="width:' + calc + '%"></div></div>');

            } else {

                $('#storyProgress').removeClass('disabled');
                $('#storyProgress .progressBar').css('width', calc + '%');

            }

            // console.log((currScroll+(winHeight*1)) + ':' + calc);

        } else {

            $('#storyProgress').addClass('disabled');

        }

    }

}

$(window).on('scroll', function () {
    storyProgress();
});
